import React from 'react'
import { pageContainer } from './styles.css'
import Image from 'next/image'

export const LoaderPage: React.FC = () => {
  return (
    <div className={pageContainer}>
      <Image
        src="/assets/v2/images/logos/creatorland_logo_loading.gif"
        alt="Creatorland"
        fill
        style={{ objectFit: 'contain' }}
      />
    </div>
  )
}
